<script>
import moment from "moment";

import { deepClone } from "@/utils/util";

import SelectInput from "@/components/input/selectInput.vue";
import SelectDatePicker from "@/components/date/selectDatePicker.vue";

import YnSelect from "./ynSelect.vue";
import YnMultipleSelect from "./ynMultipleSelect.vue";

const layout = {
  xs: 24,
  sm: 12,
  md: 8,
  lg: 6,
  xl: 4,
};
export default {
  components: { YnSelect, YnMultipleSelect, SelectInput, SelectDatePicker },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    search: {
      type: Object,
    },
  },
  data() {
    return {
      isShrink: true,
      form: {},
      defaultShortcuts: [
        {
          text: this.$t("commonTimeToday"),
          value: () => {
            let statTime = moment().startOf("day").toDate();
            let endTime = moment().endOf("day").toDate();
            return [statTime, endTime];
          },
        },
        {
          text: this.$t("commonTimeYesterday"),
          value: () => {
            const date = moment().subtract(1, "day");
            let statTime = date.startOf("day").toDate();
            let endTime = date.endOf("day").toDate();
            return [statTime, endTime];
          },
        },
        {
          text: this.$t("commonTimeNearly7"),
          value: () => {
            let statTime = moment().subtract(6, "day").startOf("day").toDate();
            let endTime = moment().endOf("day").toDate();
            return [statTime, endTime];
          },
        },
        {
          text: this.$t("commonTimeNearly30"),
          value: () => {
            let statTime = moment().subtract(29, "day").startOf("day").toDate();
            let endTime = moment().endOf("day").toDate();
            return [statTime, endTime];
          },
        },
        {
          text: this.$t("commonTimeNearly90"),
          value: () => {
            let statTime = moment().subtract(89, "day").startOf("day").toDate();
            let endTime = moment().endOf("day").toDate();
            return [statTime, endTime];
          },
        },
      ],
    };
  },
  computed: {
    shrinkLimint() {
      return this.data.length < 6;
    },
  },
  watch: {
    search: {
      handler(val) {
        this.form = {
          ...this.form,
          ...deepClone(val),
        };
      },
      deep: false,
    },
  },
  beforeMount() {
    if (this.search) {
      this.form = {
        ...this.form,
        ...deepClone(this.search),
      };
    }
  },

  mounted() {
    setTimeout(() => {
      this.$emit("strink-change", this.isShrink);
    }, 0);
  },
  methods: {
    //utils

    disabledDate(time) {
      return time.getTime() > Date.now();
    },
    setFieldValue(prop, value) {
      this.form[prop] = value;
    },

    //events
    onShrink() {
      this.isShrink = !this.isShrink;
      this.$nextTick(() => {
        this.$emit("strink-change", this.isShrink);
      });
    },

    onSearch() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit("search-change", deepClone(this.form), () => {});
        }
      });
    },
    onReset() {
      this.form = {
        ...deepClone(this.search),
      };
      this.$refs.form.clearValidate();
      this.$emit("search-reset", deepClone(this.form), () => {});
    },
    onKeyDown(e) {
      if (e.keyCode === 13) {
        this.onSearch();
      }
    },

    //UI
    renderInput(item) {
      return (
        <el-input
          v-model_trim={this.form[item.prop]}
          placeholder={this.$t("commonTipInput")}
          clearable
        />
      );
    },
    renderSelect(item) {
      return (
        <yn-select
          style="width: 100%"
          v-model={this.form[item.prop]}
          dicData={item.dicData}
          dicUrl={item.dicUrl}
          keyMap={item.props}
          clearable={item.clearable}
          multiple={item.multiple == true}
          tags={item.tags == true}
          onChange={item.onChange}
        />
      );
    },
    renderMultipleSelect(item) {
      return (
        <yn-multiple-select
          style="width: 100%"
          v-model={this.form[item.prop]}
          dicData={item.dicData}
          dicUrl={item.dicUrl}
          keyMap={item.props}
          onChange={item.onChange}
        />
      );
    },
    renderDate(item) {
      return (
        <el-date-picker
          style="width: 100%"
          type={item.dateType || "date"}
          v-model={this.form[item.prop]}
          placeholder={this.$t("commonTipInput")}
          format={item.format}
          value-format={item.valueFormat}
          default-time={item.defaultTime}
          disabled-date={
            item.disabledDate
              ? item.disabledDate
              : item.disabledDate === false
              ? undefined
              : this.disabledDate
          }
        />
      );
    },
    renderDateTime(item) {
      return (
        <el-date-picker
          style="width: 100%"
          type={item.dateType || "datetimerange"}
          v-model={this.form[item.prop]}
          range-separator={"-"}
          clearable={item.clearable}
          start-placeholder={this.$t("commonTipStartTime")}
          end-placeholder={this.$t("commonTipEndTime")}
          format={item.format || "YYYY-MM-DD HH:mm:ss"}
          value-format={item.valueFormat || "YYYY-MM-DD HH:mm:ss"}
          default-time={
            item.defaultTime || [moment().startOf("day"), moment().endOf("day")]
          }
          disabled-date={
            item.disabledDate
              ? item.disabledDate
              : item.disabledDate === false
              ? undefined
              : this.disabledDate
          }
          shortcuts={
            item.shortcuts === false
              ? undefined
              : typeof item.shortcuts === "object"
              ? item.shortcuts
              : this.defaultShortcuts
          }
        />
      );
    },
    renderSelectDatePicker(item) {
      return (
        <select-date-picker
          v-model={this.form[item.prop]}
          options={item.dicData}
          shrink={item.shrink}
          disabledDate={
            item.disabledDate
              ? item.disabledDate
              : item.disabledDate === false
              ? undefined
              : this.disabledDate
          }
          shortcuts={
            item.shortcuts === false
              ? undefined
              : typeof item.shortcuts === "object"
              ? item.shortcuts
              : this.defaultShortcuts
          }
        />
      );
    },

    renderSelectInput(item) {
      return <select-input v-model={this.form[item.prop]} options={item.dicData} />;
    },

    renderFormItemContent(item) {
      if (item.render) {
        return item.render(this.form);
      }
      switch (item.type) {
        case "select":
          return this.renderSelect(item);
        case "multipleSelect":
          return this.renderMultipleSelect(item);
        case "date":
          return this.renderDate(item);
        case "datetime":
          return this.renderDateTime(item);
        case "selectDatePicker":
          return this.renderSelectDatePicker(item);
        case "selectInput":
          return this.renderSelectInput(item);
        default:
          return this.renderInput(item);
      }
    },

    renderFormItem(item, index) {
      return (
        <el-col
          class="col"
          key={item.prop}
          {...layout}
          style={{
            display: index > 4 && this.isShrink && !this.shrinkLimint ? "none" : "block",
          }}
        >
          <el-form-item label={item.label || ` `} prop={item.prop} rules={item.rules}>
            {this.renderFormItemContent(item)}
          </el-form-item>
        </el-col>
      );
    },
    renderSearchItem() {
      return (
        <el-col class="col" key={"search"} {...layout}>
          <el-form-item>
            <div class="search-control">
              <el-button type="primary" onClick={this.onSearch}>
                {this.$t("commonBtnSearch")}
              </el-button>
              <el-button onClick={this.onReset}>{this.$t("commonBtnClear")}</el-button>
              {!this.shrinkLimint ? (
                <el-button class="icon-btn" type="primary" text onClick={this.onShrink}>
                  {this.isShrink ? (
                    <span>
                      {this.$t("commonBtnSearchOpen")}
                      <i class="el-icon-arrow-down" />
                    </span>
                  ) : (
                    <span>
                      {this.$t("commonBtnSearchShrink")}
                      <i class="el-icon-arrow-up" />
                    </span>
                  )}
                </el-button>
              ) : null}
            </div>
          </el-form-item>
        </el-col>
      );
    },
  },

  render() {
    return (
      <div class="search-header" onKeydown={this.onKeyDown}>
        <el-form ref="form" model={this.form} labelWidth="100px" labelPosition="top">
          <el-row gutter={10}>
            {this.data.map((item, index) => {
              return this.renderFormItem(item, index);
            })}
            {this.renderSearchItem()}
          </el-row>
        </el-form>
      </div>
    );
  },
};
</script>
<style lang="scss" scoped>
.search-header {
  .col {
    margin: 0;
    padding-bottom: 8px;
  }
  .search-control {
    margin-top: 25px;
  }
  :deep(.el-form-item) {
    margin-bottom: 5px !important;
  }
  .icon-btn {
    padding: 8px 0px;
  }
}
</style>
